module.exports = __webpack_public_path__ + "static/media/microphone.077cd88a.png";